export default __webpack_public_path__ + "static/clear-brilliant-1-fc8c24b2aadc522d38165119f55f4e59.jpg";